import React, { useState } from 'react';
import { Search } from 'lucide-react';
export function BoardRoles() {
  const [searchTerm, setSearchTerm] = useState('');
  const [activeFilter, setActiveFilter] = useState('All');
  const roles = [{
    name: 'Board Member',
    type: 'Board'
  }, {
    name: 'Independent Director',
    type: 'Board'
  }, {
    name: 'Chairman',
    type: 'Board'
  }, {
    name: 'Board Chair',
    type: 'Board'
  }, {
    name: 'Vice Chair',
    type: 'Board'
  }, {
    name: 'Advisory Board Member',
    type: 'Board'
  }, {
    name: 'Lead Director',
    type: 'Board'
  }, {
    name: 'Committee Chair',
    type: 'Committee'
  }, {
    name: 'Audit Committee Chair',
    type: 'Committee'
  }, {
    name: 'Risk Committee Chair',
    type: 'Committee'
  }, {
    name: 'Compensation Committee Chair',
    type: 'Committee'
  }, {
    name: 'Governance Committee Chair',
    type: 'Committee'
  }, {
    name: 'Nominating Committee Chair',
    type: 'Committee'
  }, {
    name: 'CEO',
    type: 'C-Suite'
  }, {
    name: 'President',
    type: 'C-Suite'
  }, {
    name: 'COO',
    type: 'C-Suite'
  }, {
    name: 'CFO',
    type: 'C-Suite'
  }, {
    name: 'CIO',
    type: 'C-Suite'
  }, {
    name: 'CTO',
    type: 'C-Suite'
  }, {
    name: 'CHRO',
    type: 'C-Suite'
  }, {
    name: 'CISO',
    type: 'C-Suite'
  }, {
    name: 'Chief Strategy Officer',
    type: 'C-Suite'
  }, {
    name: 'Chief Transformation Officer',
    type: 'C-Suite'
  }, {
    name: 'Managing Director',
    type: 'Executive'
  }, {
    name: 'Executive Vice President',
    type: 'Executive'
  }, {
    name: 'Senior Vice President',
    type: 'Executive'
  }];
  const filters = ['All', 'Board', 'Committee', 'C-Suite', 'Executive'];
  const filteredRoles = roles.filter(role => {
    const matchesSearch = role.name.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter = activeFilter === 'All' || role.type === activeFilter;
    return matchesSearch && matchesFilter;
  });
  return <section className="py-24 bg-charcoal-900 text-white" data-id="element-39">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-40">
        <div className="text-center mb-12" data-id="element-41">
          <h2 className="text-3xl md:text-5xl font-serif-display font-bold mb-6" data-id="element-42">
            Roles We Support
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg mb-10" data-id="element-43">
            We position leaders for the most critical roles in corporate
            governance and executive management.
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-4 mb-10" data-id="element-44">
            <div className="relative w-full max-w-md" data-id="element-45">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-46">
                <Search className="h-4 w-4 text-gray-400" data-id="element-47" />
              </div>
              <input type="text" className="block w-full pl-10 pr-3 py-3 border border-navy-700 rounded-sm leading-5 bg-navy-800 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gold focus:border-gold sm:text-sm transition-all" placeholder="Search roles..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-48" />
            </div>

            <div className="flex flex-wrap justify-center gap-2" data-id="element-49">
              {filters.map(filter => <button key={filter} onClick={() => setActiveFilter(filter)} className={`px-4 py-2 text-sm font-medium rounded-sm transition-colors ${activeFilter === filter ? 'bg-gold text-navy-900' : 'bg-navy-800 text-gray-300 hover:bg-navy-700'}`} data-id="element-50">
                  {filter}
                </button>)}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-51">
          {filteredRoles.map((role, index) => <div key={index} className="bg-navy-800/50 border border-navy-700 p-4 rounded-sm flex flex-col justify-center items-center text-center hover:border-gold/50 transition-colors" data-id="element-52">
              <span className="font-semibold text-gray-100" data-id="element-53">{role.name}</span>
              <span className="text-xs text-gold mt-1 uppercase tracking-wider" data-id="element-54">
                {role.type}
              </span>
            </div>)}
        </div>

        {filteredRoles.length === 0 && <div className="text-center py-12 text-gray-500" data-id="element-55">
            No roles found matching your criteria.
          </div>}
      </div>
    </section>;
}